(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom-vertical-gallery"] && !Shopify.designMode) return;
  try {
    class CustomVerticalGallery {
    constructor(element) {
      this.element = element;
      this.thumbnailsEl = element.querySelector('[data-gallery-thumbnails]');
      this.slidesEl = element.querySelector('[data-gallery-slides]');
      this.dotsEl = element.querySelector('[data-gallery-dots]');
      this.sliderPrevBtn = element.querySelector('[data-slider-prev]');
      this.sliderNextBtn = element.querySelector('[data-slider-next]');
      
      this.mainSwiper = null;
      this.thumbSwiper = null;

      this.init();
    }

    init() {
      if (!window.Swiper) {
        console.error('Swiper library not loaded');
        return;
      }

      // Initialize thumbnail swiper (desktop only)
      if (this.thumbnailsEl) {
        this.thumbSwiper = new Swiper(this.thumbnailsEl, {
          direction: 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchSlidesProgress: true,
          freeMode: true,
        });
      }

      // Initialize main slider
      const mainConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: this.sliderNextBtn,
          prevEl: this.sliderPrevBtn,
        },
      };

      // Add pagination for mobile
      if (this.dotsEl) {
        mainConfig.pagination = {
          el: this.dotsEl,
          clickable: true,
          dynamicBullets: false,
        };
      }

      // Add thumbs connection for desktop
      if (this.thumbSwiper) {
        mainConfig.thumbs = {
          swiper: this.thumbSwiper,
        };
      }

      // Enable touch on mobile
      const isMobile = window.innerWidth < 750;
      if (isMobile) {
        mainConfig.allowTouchMove = true;
        mainConfig.effect = 'slide';
      } else {
        mainConfig.allowTouchMove = false;
      }

      this.mainSwiper = new Swiper(this.slidesEl, mainConfig);

      // Sync active states
      if (this.thumbSwiper) {
        this.mainSwiper.on('slideChange', () => {
          this.updateThumbnailStates();
        });

        // Handle thumbnail clicks
        const thumbnails = this.element.querySelectorAll('[data-gallery-thumbnail]');
        thumbnails.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            this.mainSwiper.slideTo(index);
          });
        });
      }

      // Update initial state
      this.updateThumbnailStates();

      // Handle window resize
      window.addEventListener('resize', () => {
        const nowMobile = window.innerWidth < 750;
        if (this.mainSwiper) {
          this.mainSwiper.params.allowTouchMove = nowMobile;
          this.mainSwiper.update();
        }
      });
    }

    updateThumbnailStates() {
      if (!this.mainSwiper) return;
      
      const activeIndex = this.mainSwiper.activeIndex;
      const thumbnails = this.element.querySelectorAll('[data-gallery-thumbnail]');
      
      thumbnails.forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-selected', 'false');
          thumb.removeAttribute('aria-current');
        }
      });
    }

    destroy() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy();
      }
      if (this.thumbSwiper) {
        this.thumbSwiper.destroy();
      }
    }
  }

  const initCustomVerticalGalleries = () => {
    document.querySelectorAll('[data-custom-vertical-gallery]').forEach((gallery) => {
      if (gallery.__customVerticalGalleryInstance) {
        gallery.__customVerticalGalleryInstance.destroy();
      }
      gallery.__customVerticalGalleryInstance = new CustomVerticalGallery(gallery);
    });
  };

  // Wait for Swiper to load
  const waitForSwiper = () => {
    if (window.Swiper) {
      initCustomVerticalGalleries();
    } else {
      setTimeout(waitForSwiper, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiper);
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', () => setTimeout(initCustomVerticalGalleries, 100));
  document.addEventListener('shopify:section:select', () => setTimeout(initCustomVerticalGalleries, 100));

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', () => setTimeout(initCustomVerticalGalleries, 100));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_discount-codes"] && !Shopify.designMode) return;
  try {
    class DiscountCodes {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.cards = wrapper.querySelectorAll('[data-discount-card]');
      this.init();
    }

    init() {
      this.cards.forEach(card => {
        card.addEventListener('click', () => this.copyCode(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.copyCode(card);
          }
        });
      });
    }

    async copyCode(card) {
      const code = card.dataset.code;
      const copiedMessage = card.querySelector('[data-copied-message]');

      try {
        // Try using the Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          // Fallback for older browsers
          const textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }

        // Show copied message
        copiedMessage.classList.add('show');
        
        // Hide after 2 seconds
        setTimeout(() => {
          copiedMessage.classList.remove('show');
        }, 2000);

      } catch (err) {
        console.error('Failed to copy code:', err);
      }
    }
  }

  const initDiscountCodes = () => {
    document.querySelectorAll('[data-discount-codes]').forEach(wrapper => {
      if (!wrapper.__discountCodesInstance) {
        wrapper.__discountCodesInstance = new DiscountCodes(wrapper);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountCodes);
  } else {
    initDiscountCodes();
  }

  document.addEventListener('shopify:section:load', initDiscountCodes);
  document.addEventListener('shopify:section:select', initDiscountCodes);
  } catch(e) { console.error(e); }
})();

})();
